import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import * as models from '../../models';

export interface IAircraftCategoriesService {
  getAircraftCategoryList(
    request: GetAircraftCategoryListRequest
  ): Observable<GetAircraftCategoryListResponse>;
}

export const SERVICE_TOKEN = new InjectionToken('Shared.IAircraftCategoriesService');

export class GetAircraftCategoryListRequest {}

export class GetAircraftCategoryListResponse {
  entities: Array<models.AircraftCategory> = [];
}
